import React from "react";
import { Send, Copy as CopyIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const STATUS = {
  not_sent: ["Simulazione — non inviato", "bg-sand-100 text-ink-700 border-sand-300"],
  accepted: ["Accettato da Meta", "bg-sky-50 text-sky-900 border-sky-300"],
  replayed: ["Già inviato (nessun duplicato)", "bg-sand-100 text-ink-700 border-sand-300"],
  unknown: ["Esito da verificare", "bg-amber-50 text-amber-900 border-amber-300"],
  failed: ["Non inviato — errore", "bg-rose-50 text-rose-800 border-rose-200"],
};
const DELIVERY = { sent: "Inviato", delivered: "Consegnato", read: "Letto", failed: "Fallito" };
const CHANNEL = { whatsapp_cloud_api: "WhatsApp (Meta Cloud API)", simulation: "Simulazione" };

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", {
  timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

export default function ReservationNotificationCard({ r, canEdit, onCopy, onResend, sending, available }) {
  const n = r.last_notification;
  const legacy = !n && r.confirmation_channel;
  const [label, cls] = n ? (STATUS[n.status] || [n.status, STATUS.not_sent[1]]) : ["Nessuna notifica richiesta", STATUS.not_sent[1]];
  return (
    <section data-testid="reservation-notification">
      <h3 className="text-xs uppercase tracking-wider text-ink-500 mb-2">Messaggio WhatsApp</h3>
      <div className="rounded-md border border-sand-300 bg-sand-50 p-2 text-xs space-y-1.5">
        {n && (
          <>
            <div className="flex flex-wrap items-center gap-2">
              <b data-testid="notif-kind">{n.kind_label || n.kind}</b>
              <span className={`rounded-full border px-2 py-0.5 ${cls}`} data-testid="notif-status">{label}</span>
              {n.delivery_status && <span className="rounded-full border border-emerald-300 bg-emerald-50 text-emerald-900 px-2 py-0.5"
                                         data-testid="notif-delivery">{DELIVERY[n.delivery_status] || n.delivery_status}</span>}
            </div>
            <div data-testid="notif-channel">Canale: {CHANNEL[n.channel] || n.channel}{n.template ? ` · template ${n.template}` : ""}</div>
            <div>{n.status === "accepted" ? "Inviato il" : "Registrato il"} {fmt(n.at)}{n.sent_by_name ? ` · da ${n.sent_by_name}` : ""}</div>
            {n.error && <div className="text-rose-700" data-testid="notif-error">Motivo: {n.error}</div>}
          </>
        )}
        {legacy && (
          <div data-testid="notif-legacy">
            Sistema precedente: {r.confirmation_channel === "mock" ? "simulazione (mai inviato al cliente)" : r.confirmation_channel}
          </div>
        )}
        {!n && <div data-testid="notif-none">{label}</div>}
        <div className="flex items-center gap-2">
          <Input value={r.confirm_url || ""} readOnly className="text-[10px] font-mono h-9" data-testid="edit-confirm-url" />
          <Button size="sm" variant="outline" onClick={onCopy} className="h-9" data-testid="edit-copy-link">
            <CopyIcon className="w-3 h-3 mr-1" /> Copia
          </Button>
          {canEdit && (
            <Button size="sm" variant="outline" onClick={onResend} disabled={sending || !available} className="h-9"
                    title={available ? "" : "Disponibile dopo attivazione WhatsApp"} data-testid="edit-resend">
              <Send className="w-3 h-3 mr-1" /> {sending ? "Invio…" : n ? "Rinvia" : "Invia"}
            </Button>
          )}
        </div>
        {canEdit && !available && (
          <div className="text-[11px] text-ink-500" data-testid="notif-unavailable">Invio disponibile dopo attivazione WhatsApp</div>
        )}
      </div>
    </section>
  );
}
